// Custom components
import { Button, FormControl, FormHelperText, FormLabel, IconButton, Input, InputGroup, InputLeftElement, InputRightElement } from "@chakra-ui/react";
import React from "react";

function InputField(props) {
  const { label, iconleft = null, onClick = null, extraInput = '', helperText = '', readOnly = false, iconLoading = null, autoComplete = 'on', onClickIconRight, iconright = null, id, required = false, extra, type, placeholder, variant, state, disabled, value, name, onChange, onBlur = () => { return }, maxLength = 100, minLength = 0, autoFocus = false, min = 1, max = 10000, extrainput = '' } =
    props;

  return (
    <div className={`relative ${extra}`}>
      <FormControl isRequired={required}>
        <FormLabel
          htmlFor={id}
          className="!text-sm !text-navy-700 dark:!text-white !font-semibold tracking-wide mb-1"
        >
          {label}
        </FormLabel>

        <InputGroup>
          {iconleft && (
            <InputLeftElement
              className="text-gray-600 dark:text-gray-300 mt-[2px]"
              pointerEvents="none"
              fontSize="1.1em"
            >
              {iconleft}
            </InputLeftElement>
          )}

          <Input
            id={id}
            name={name}
            type={type}
            value={value}
            placeholder={placeholder}
            isDisabled={disabled}
            isReadOnly={readOnly}
            isRequired={required}
            autoFocus={autoFocus}
            autoComplete={autoComplete}
            minLength={minLength}
            maxLength={maxLength}
            min={min}
            max={max}
            step={0.01}
            variant="filled"
            size="lg"
            onChange={onChange}
            onBlur={onBlur}
            className={`flex w-full !rounded !border-[2.5px] !transition-all !duration-200 !ease-in-out
            ${disabled
                ? `!bg-gray-50 !opacity-50 dark:!bg-navy-700
                !text-gray-800 dark:!text-gray-400
                   !border-gray-300 dark:!border-navy-700
                   !cursor-not-allowed
                   focus:!border-gray-300 focus:!ring-0
                   hover:!border-gray-300 dark:hover:!border-navy-700
                   shadow-none`
                : `!bg-lightPrimary dark:!bg-navy-900
                !text-gray-800 dark:!text-white
                !border-gray-300 dark:!border-white/10
                   focus:!border-brand-500 focus:!ring-[1px] focus:!ring-brand-500
                   dark:focus:!border-brand-400 dark:focus:!ring-brand-400
                   hover:!border-brand-500 dark:hover:!border-brand-400
                   placeholder:!text-gray-400 dark:placeholder:!text-gray-500
                   focus:!shadow-sm`
              }
            !text-sm
            ${extraInput}`}
          />

          {iconright && (
            <InputRightElement className="mt-[4px] mr-[5px]">
              <IconButton
                aria-label="Acción"
                colorScheme="brand"
                isLoading={disabled}
                onClick={onClickIconRight}
                className="!h-9 !w-9 flex items-center justify-center 
            !rounded bg-navy-50 hover:!bg-navy-100 active:!bg-navy-200 
            dark:!bg-navy-700 dark:hover:!bg-navy-800 dark:active:!bg-navy-900"
              >
                {iconright}
              </IconButton>
            </InputRightElement>
          )}
        </InputGroup>

        {helperText && (
          <FormHelperText className="!mt-1 !text-xs !text-brand-500 dark:!text-brand-200 opacity-80">
            {helperText}
          </FormHelperText>
        )}
      </FormControl>
    </div>
  );
}

export default InputField;
